import script from "./qualification.vue?vue&type=script&setup=true&lang=js"
export * from "./qualification.vue?vue&type=script&setup=true&lang=js"

import "./qualification.vue?vue&type=style&index=0&id=31bfb472&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.member/src/fe-member/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31bfb472"]])

export default __exports__